// extracted by mini-css-extract-plugin
export default {"DashbardOuterContainer":"cmsDashBoard_DashbardOuterContainer__V5LcD","MainContentContainer":"cmsDashBoard_MainContentContainer__T4lGG"};